import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import AnimalData from '../../data/Animals';
import styles from './Animals.styl';
import ScrollIconRight from '-!svg-react-loader!../../assets/Icon_scroll_arrows_right.svg';
import ScrollIconLeft from '-!svg-react-loader!../../assets/Icon_scroll_arrows_left.svg';
/* eslint import/no-webpack-loader-syntax: off */

let regularSize = 150;

let sortedAnimalData = AnimalData.sort(function(a, b) {
  return a.order - b.order;
});

class Animals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalSlides: AnimalData.length
    };

    this.slideLeft = this.slideLeft.bind(this);
    this.slideRight = this.slideRight.bind(this);
  }

  componentDidMount() {
    this.setCurrentSlide(this.state.totalSlides);
    // When our row transition ends, we check if we're outside the bounds of our "center" group,
    // then jump back to the center group without a transition. The next call of setCurrentSlide
    // will restore the transition. This approach to infinite slides works so long as the list of slides
    // is wider than the viewport.
    this.refs.animalRow.addEventListener('transitionend', e => {
      if (e.target !== this.refs.animalRow) {
        return;
      }
      if (
        this.state.selectedSlide < this.state.totalSlides ||
        this.state.selectedSlide >= this.state.totalSlides * 2
      ) {
        this.setCurrentSlide(
          this.state.totalSlides +
            this.state.selectedSlide % this.state.totalSlides,
          true
        );
      }
    });
  }

  setCurrentSlide(i, clicked) {
    this.setState({
      selectedSlide: i
    });
    this.props.setSelectedSlide(i % this.state.totalSlides);
    if(clicked){
      this.props.scrollToAnimals();
    }
  }

  slideLeft() {
    let newSlide = this.state.selectedSlide - 1;
    this.setState({
      selectedSlide: newSlide
    });
    this.props.setSelectedSlide(newSlide % this.state.totalSlides);
  }

  slideRight() {
    let newSlide = this.state.selectedSlide + 1;
    this.setState({
      selectedSlide: newSlide
    });
    this.props.setSelectedSlide(newSlide % this.state.totalSlides);
  }

  render() {
    const rowStyles = {
      transform: `translateX(${(this.state.totalSlides -
        this.state.selectedSlide) *
        regularSize}px)`,
      width: `${this.state.totalSlides * regularSize}px`
    };
    if (this.state.disableTransition) {
      rowStyles.transition = 'none';
    }
    let slideIndex = -1;
    return (
      <div className={styles.arrowWrapper} ref="AnimalWrapper">
        <div className={styles.leftFade} />
        <div className={styles.rightFade} />
        <ScrollIconLeft height={40} width={40} className={styles.leftArrow} onClick={this.slideLeft}/>
        <ScrollIconRight height={40} width={40} className={styles.rightArrow} onClick={this.slideRight}/>
        <div className={styles.animalCarouselClip}>
          <div className={styles.animalCarouselWrapper}>
            <div
              ref="animalRow"
              className={styles.animalRowWrapper}
              style={rowStyles}
            >
              {['Left', 'Center', 'Right'].map(position => {
                return (
                  <div
                    key={position}
                    className={
                      styles.animalCarouselInfinite +
                      ' ' +
                      styles['animalCarousel' + position]
                    }
                  >
                    {sortedAnimalData.map(animal => {
                      let i = ++slideIndex;
                      return (
                        <img
                          className={styles.animalImage}
                          src={animal.blockImage}
                          alt=""
                          key={i}
                          onClick={() => this.setCurrentSlide(i, true)}
                        />
                      );
                    })}
                  </div>
                );
              })}
            </div>
            <div className={styles.gradientLine} />

            <div className={styles.verticalLine} />
          </div>
        </div>
      </div>
    );
  }
}

export default Animals;



// WEBPACK FOOTER //
// ./src/components/carousel/Animals.js